import DatePicker from '@components/date-picker';
import cn from 'clsx';
import { isAfter, startOfToday } from 'date-fns';
import { observer } from 'mobx-react-lite';

import { Field } from 'components/Field';
import { useStore } from 'hooks/useStore';

import css from './Manual.module.css';

const currentDate = startOfToday();

const Manual = () => {
  const {
    app: { i18n, locale },
    filter: {
      loadDate: { isManualDateActive, setFromDate, setToDate, fromDate, toDate, setDateOption },
    },
  } = useStore();

  const handleFromDateChange = (date: Date | null) => {
    if (date && toDate && isAfter(date.setHours(0, 0, 0, 0), toDate)) {
      setToDate(null);
    }
    setFromDate(date);
  };

  const handleToDateChange = (date: Date | null) => {
    setToDate(date);
  };

  const handleClick = () => {
    setDateOption('manual');
  };

  const renderDatePicker = () => {
    if (isManualDateActive) {
      return (
        <>
          <Field
            isRow
            containerClassName={css.dateField}
            contentClassName={css.dateInput}
            labelClassName={css.fieldLabel}
            labelText={i18n.dates.from}
          >
            <DatePicker
              className={css.datepickerInput}
              classNames={{
                inputMask: css.datepickerInput,
              }}
              isClearable={false}
              locale={locale}
              minDate={currentDate}
              value={fromDate}
              onChange={handleFromDateChange}
            />
          </Field>

          <Field
            isRow
            containerClassName={css.dateField}
            contentClassName={css.dateInput}
            labelClassName={css.fieldLabel}
            labelText={i18n.dates.to}
          >
            <DatePicker
              className={css.datepickerInput}
              classNames={{
                inputMask: css.datepickerInput,
              }}
              isClearable={true}
              locale={locale}
              minDate={fromDate || currentDate}
              value={toDate}
              onChange={handleToDateChange}
            />
          </Field>
        </>
      );
    }

    return (
      <button className={cn(css.button, 'glz-link')} type="button" onClick={handleClick}>
        {i18n.dates.exactDate}
      </button>
    );
  };

  return <div className={css.container}>{renderDatePicker()}</div>;
};

const connected = observer(Manual);

export { connected as Manual };
